import {
  $isListNode,
  INSERT_ORDERED_LIST_COMMAND,
  INSERT_UNORDERED_LIST_COMMAND,
  ListType,
  REMOVE_LIST_COMMAND,
} from '@lexical/list';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $getSelection, $isRangeSelection, LexicalCommand } from 'lexical';
import { Maybe, fromNullable, nothing } from 'maybeasy';
import * as React from 'react';
import StyleButton from './StyleButton';

const BLOCK_TYPES: ReadonlyArray<{
  label: string;
  listType: ListType;
  command: LexicalCommand<void>;
}> = [
  { label: 'UL', listType: 'bullet', command: INSERT_UNORDERED_LIST_COMMAND },
  { label: 'OL', listType: 'number', command: INSERT_ORDERED_LIST_COMMAND },
];

const BlockStyleControls: React.FC = () => {
  const [editor] = useLexicalComposerContext();
  const [activeListType, setActiveListType] = React.useState<Maybe<ListType>>(nothing());

  React.useEffect(
    () =>
      editor.registerUpdateListener(({ editorState }) => {
        editorState.read(() => {
          const selection = $getSelection();
          if ($isRangeSelection(selection)) {
            const anchorNode = selection.anchor.getNode();
            setActiveListType(
              fromNullable([anchorNode, ...anchorNode.getParents()].find($isListNode)).map(
                (listNode) => listNode.getListType(),
              ),
            );
          } else {
            setActiveListType(nothing());
          }
        });
      }),
    [editor],
  );

  const isActive = (listType: ListType): boolean =>
    activeListType.map((active) => active === listType).getOrElseValue(false);

  return (
    <>
      {BLOCK_TYPES.map((type) => (
        <StyleButton
          key={type.label}
          active={isActive(type.listType)}
          label={type.label}
          onToggle={() =>
            isActive(type.listType)
              ? editor.dispatchCommand(REMOVE_LIST_COMMAND, undefined)
              : editor.dispatchCommand(type.command, undefined)
          }
          style={type.listType}
        />
      ))}
    </>
  );
};

export default BlockStyleControls;
